<template>
  <div>
    <v-simple-table class="table-layout pa-5">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="th-id">
              #
            </th>
            <th>Tên đăng nhập</th>
            <th>Họ và tên</th>
            <th>Ảnh đại diện</th>
            <th>Email</th>
<!--            <th>Phòng ban</th>-->
            <th>Máy lẻ</th>
            <th>Tổng đài</th>
            <th>Đầu số TĐ</th>
<!--            <th>Chức danh</th>-->
            <th>Đăng nhập lần cuối</th>
            <th v-if="showAction">Thao tác</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(user, index) in users">
            <tr
              :key="user.id"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ _.get(user, 'username') }}</td>
              <td>{{ _.get(user, 'fullName')}}</td>
              <td>
                <v-list-item-avatar
                  class="align-self-center"
                  color="grey"
                >
                  <img
                    v-if="_.get(user, 'avatar.id')"
                    class=""
                    :src="_.get(user, 'avatar.filePath', '')"
                  />
                  <v-img
                    v-else
                    class=""
                    src="@/assets/default-avatar.jpg"
                  />
                </v-list-item-avatar>
              </td>
              <td>{{ _.get(user, 'email') }}</td>
<!--              <td>{{ _.get(user, 'department.name') }}</td>-->
              <td>{{ _.get(user, 'ext') }}</td>
              <td>{{ getNameSwitchBoard(_.get(user, 'callcenter_id')) }}</td>
              <td>{{ _.get(user, 'fromNumber') | formatFromNumber}}</td>
<!--              <td>{{ _.get(userPositionOptions.find(position => position.value === user.position), 'text', '') }}</td>-->
              <td>{{ _.get(user, 'lastLoginAt') }}</td>
              <td v-if="showAction">
                <div class="action">
                    <v-tooltip v-if="user.status ==='inactive'" bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon  @click="convertStatus(user.id,'active')" size="22" color="info" icon v-on="on">mdi-block-helper</v-icon>
                      </template>
                      <span>Chuyển sang trạng thái hoạt động</span>
                    </v-tooltip>
                    <v-tooltip v-else bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon  @click="convertStatus(user.id,'inactive')" size="22" color="success" icon v-on="on">mdi-checkbox-marked-circle</v-icon>
                      </template>
                      <span>Chuyển sang trạng thái ngừng hoạt động</span>
                    </v-tooltip>
                  <v-tooltip bottom v-if="checkAuthorization('user_update')">
                    <template v-slot:activator="{ on }">
                      <v-btn class="mr-2"  @click="editUser(user)" icon small color="primary" dark v-on="on"><v-icon>mdi-pencil</v-icon></v-btn>
                    </template>
                    <span>Cập nhật thông tin người dùng</span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="checkAuthorization('user_update')">
                    <template v-slot:activator="{ on }">
                      <v-btn class="mr-2"  @click="resetPassword(user)" icon small color="info" dark v-on="on"><v-icon>mdi-lock-reset</v-icon></v-btn>
                    </template>
                    <span>Cập nhật mật khẩu người dùng</span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="checkAuthorization('user_delete')">
                    <template v-slot:activator="{ on }">
                      <v-btn @click="onClickDelete(user)" icon small color="default" v-on="on"><v-icon>mdi-delete</v-icon></v-btn>
                    </template>
                    <span>Xóa người dùng</span>
                  </v-tooltip>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>
<script>
  import RepositoryFactory from '../../../repositories/RepositoryFactory'
  import { userPositionOptions } from '../../../helpers/constants'
  import { SWITCH_BOARD } from '@/constants/common';

  const UserRepository = RepositoryFactory.get('user')
  export default {
    props: {
      filterForm: {
        type: Object,
        default: () => {},
      },
      users: {
        type: Array,
        default: () => [],
      },
      departments: {
        default: () => ([]),
      },
    },
    data () {
      return {
        selectedUser: {},
        modalAlert: false,
        errorMessage: '',
        userPositionOptions,
        SWITCH_BOARD,
      }
    },
    computed: {
      showAction () {
        return this.checkAuthorization('user_update') || this.checkAuthorization('user_delete');
      }
    },
    methods: {
      getNameSwitchBoard (id) {
        return _.get(this.SWITCH_BOARD.find(item => item.id === id), 'name', '')
      },
      async convertStatus(id, status) {
        const statusUser = {
          status,
        }
        this.$swal({
          title: 'Chuyển đổi trạng thái',
          text: 'Bạn có thực sự chắc chắn ?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Đồng ý',
          cancelButtonText: 'Hủy bỏ',
        }).then(async (result) => {
          if (result.value) {
            // const loader = this.$loading.show()
            this.appLoadingData(true)
            const response = await UserRepository.updateStatus(id, statusUser)
            // loader.hide()
            this.appLoadingData(false)
            if (response.success) {
              this.$swal({
                        title: 'Chuyển đổi thành công !',
                        confirmButtonText: 'Đồng ý',
                      },
              ).then(() => {
                Bus.$emit('user-list-reload')
              })
            } else {
              this.$swal({
                type: 'error',
                title: 'Lỗi !',
                text: _.get(response, 'message', ''),
              })
            }
          }
        })
      },
      editUser (user) {
        this.selectedUser = user
        Bus.$emit('user-show-user-form-new', this.selectedUser)
      },
      resetPassword (user) {
        this.selectedUser = user
        Bus.$emit('reset-password-user', this.selectedUser)
      },
      async onClickDelete (user) {
        this.$swal({
          title: 'Xóa người dùng',
          text: 'Bạn có thực sự muốn xóa ?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Đồng ý',
          cancelButtonText: 'Hủy bỏ',
        }).then(async (result) => {
          if (result.value) {
            // const loader = this.$loading.show()
            this.appLoadingData(true)
            const respond = await UserRepository.delete(user.id)
            // loader.hide()
            this.appLoadingData(false)
            if (_.get(respond, 'success', false)) {
              this.$swal({
                title: 'Đã xóa thành công !',
                confirmButtonText: 'Đồng ý',
              },
              ).then(() => {
                Bus.$emit('user-list-reload')
              })
            } else {
              this.$swal({
                type: 'error',
                title: 'Lỗi !',
                text: _.get(respond, 'message', ''),
              })
            }
          }
        })
      },
    },
    filters: {
      formatFromNumber(value) {
        if (!value) return '';
        let lastThreeDigits = value.match(/\d{0,3}$/)[0];

        return lastThreeDigits.padStart(3, '0');
      }
    }
  }
</script>

<style scoped>
.table-layout {
  text-align: center;
}
.table-layout th {
  text-align: center !important;
  min-width: 130px;
  font-size: 14px;
  font-weight: 500 !important;
  position: relative;
}
.table-layout th.th-id {
  width: 50px;
}

.table-layout tbody tr {
  height: 80px;
}
.table-layout tbody tr:hover {
  background: rgba(0, 0, 0, 0.11) !important;
}
</style>
